import { Table, Pagination } from "antd";
import React, {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {
  Avatar_01,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
  Avatar_11,
  Avatar_12,
  Avatar_13,
  Avatar_16,
  eye,
  laptop,
} from "Routes/ImagePath";
import Select from "react-select";
import { getAssetsApi } from "api/services/employee";
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import { formatDateHandler2 } from "utils/common";
import { useMediaQuery } from "react-responsive";
import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";
import Image from "components/Image";



const Assets = ({userData}) => {
  
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
const [view, setView] = useState(isMobile? "grid":"list");


  const [assets, setAssets] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
      sortType: "asc",
      sortBy: "asset__name"
    })

  useEffect(()=>{
    console.log(userData, "USERRRRRR")
    if(userData?.id){
      let params = {
        user: userData?.id,
        sort_by: pageSettings?.sortBy,
        sort_type: pageSettings?.sortType,
        page_size: pageSettings?.pageSize,
        page: pageSettings?.page,
        company_user: userData?.id,

    }
    setLoading(true)
    getAssetsApi(params).then(response=>{
        setAssets(response.data.results)
        setLoading(false)
        setPageSettings({
            ...pageSettings,
            total: response.data.count
        })
    })
    }

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, userData])

  const handleChange = (pagination, filters, sorter) =>{
      let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
      setPageSettings(pageData)
  }

 
  const columns = [
    {
      title: "Name",
      dataIndex: "asset__name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex align-items-center">
          <a className="avatar">
            <Image 
              src={record?.asset?.image} 
              type="object" 
              style={{ 
                width: "40px", 
                height: "40px", 
                objectFit: "contain", 
                borderRadius: "4px" 
              }}
            />
          </a>
          <div>
            <a className="profile-split d-flex flex-column">
              {record?.asset.name} 
            </a>
            <small className="table-avatar">
              {record?.asset.class_code}
            </small>
          </div>
        </h2>
      )       
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label">
          <span >{record?.asset?.description}</span>  
        </div>
      )   
    },
    {
      title: "Brand",
      dataIndex: "brand",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
          <span className={`badge badge-soft-warning`}>{record?.asset?.brand}</span>  
        </div>
      )   
    },
    {
      title: "Serial No",
      dataIndex: "serial_number",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record?.asset?.serial_number}
        </span>
      )   
    },
    {
      title: "Current Value",
      dataIndex: "current_value",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">{record?.asset?.current_value}</span>
      )
    },
    // {
    //   title: "Current Owner",
    //   dataIndex: "current_user",
    //   sorter: true,
    //   render: (text, record) => (
    //     <h2 className="table-avatar d-flex">
    //       <a className="avatar">
    //         <Image 
    //           src={record?.company_user?.profile_image} 
    //           type="object"
    //         />
    //       </a>
    //       <div>
    //         <a className="profile-split d-flex flex-column">
    //           {record?.company_user?.first_name} {record?.company_user?.last_name} 
    //         </a>
    //         <small className="table-avatar">
    //           {record?.company_user?.emp_no}
    //         </small>
    //       </div>
    //     </h2>
    //   )   
    // },
    // {
    //   title: "Purchase Date",
    //   dataIndex: "purchase_date",
    //   sorter: true,
    //   align: "center",
    //   render: (text, record) => (
    //     <>{formatDateHandler2(record?.asset?.purchase_date) || "-"}</>
    //   ),
    // },
    // {
    //   title: "Purchase Value",
    //   dataIndex: "purchase_value",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record?.asset?.purchase_value}
    //     </span>
    //   )   
    // },
    
    {
      title: "Assigned Date",
      dataIndex: "issue_date",
      sorter: true,
      render: (text, record) => (
        <>{formatDateHandler2(record?.issue_date) || "-"}</>
      ),
    },
    {
      title: "Return Date",
      dataIndex: "return_date",
      sorter: true,
      render: (text, record) => (
        <>{formatDateHandler2(record?.return_date) || "-"}</>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (text, record) => (
        <>
        {record?.asset?.status ? <span className="badge badge-soft-success">Assigned</span> : <span className="badge badge-soft-danger">Unassigned</span>}
        </>
      ),
    },
  ];

  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  // const handleAssetDetailPage = (id, index) => {		
  //   // console.log(id, "----ASSET ID----")	
  //   // return					  
  //    navigate(`/assets/${id}`)
  //   //  setSelectedPage(index)
  //  }

   
  const EmptyState = () => (
    <div className="col-12" style={{ 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      padding: isMobile ? "60px 20px" : "80px 40px",
      textAlign: "center"
    }}>
      <div style={{
        width: isMobile ? "120px" : "150px",
        height: isMobile ? "120px" : "150px",
        marginBottom: "24px",
        opacity: 0.6
      }}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7Z" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 21V5C16 4.5 15.5 4 15 4H9C8.5 4 8 4.5 8 5V21" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h3 style={{ 
        fontSize: isMobile ? "18px" : "20px", 
        fontWeight: "600", 
        color: "#1f2937",
        marginBottom: "8px"
      }}>
        No Assets Found
      </h3>
      <p style={{ 
        fontSize: isMobile ? "14px" : "15px", 
        color: "#6b7280",
        margin: 0,
        maxWidth: "400px"
      }}>
        This employee doesn't have any assigned assets yet.
      </p>
    </div>
  );

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else if (assets.length === 0) {
      return <EmptyState />;
    } else {
      return (
        <>
          {assets.map((asset, index) => (
            <div
              className="col-md-6 col-sm-12 col-lg-6 col-xl-4 col-xxl-3"
              key={asset.id}
              style={isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : {}}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: isMobile ? 0 : "0 0 20px 0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden"
              }}>
                <div style={{
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  zIndex: 10
                }}>
                  <a style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ffffff",
                    textDecoration: "none",
                    boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                    cursor: "pointer"
                  }}>
                    <i className="la la-edit" style={{ fontSize: "14px" }}></i>
                  </a>
                </div>
                <div className="card-body" style={{ padding: isMobile ? "16px" : "20px" }}>
                  <div style={{ 
                    display: "flex", 
                    alignItems: "flex-start", 
                    gap: "16px",
                    marginBottom: "16px"
                  }}>
                    <div style={{
                      width: isMobile ? "80px" : "100px",
                      height: isMobile ? "80px" : "100px",
                      borderRadius: "8px",
                      overflow: "hidden",
                      background: "#f3f4f6",
                      border: "1px solid #e5e7eb",
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px"
                    }}>
                        <Image 
                          src={asset?.asset?.image} 
                        type="object" 
                          alt="Asset Image" 
                          style={{ 
                            width: "100%", 
                            height: "100%", 
                            objectFit: "contain", 
                            borderRadius: "4px" 
                          }} 
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <h4 style={{ 
                        fontSize: isMobile ? "15px" : "16px",
                        fontWeight: "600",
                        color: "#1f2937",
                        marginBottom: "4px",
                        lineHeight: "1.3"
                      }}>
                        {asset?.asset?.name}
                    </h4>
                      {asset?.asset?.class_code && (
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#6b7280",
                          marginBottom: "8px"
                        }}>
                          Code: {asset?.asset?.class_code}
                        </div>
                      )}
                      {asset?.asset?.brand && (
                        <span className="badge badge-soft-warning" style={{
                          fontSize: "11px",
                          padding: "4px 8px",
                          borderRadius: "4px"
                        }}>
                          {asset?.asset?.brand}
                        </span>
                      )}
                    </div>
                  </div>
                  
                  <div style={{
                    borderTop: "1px solid #e5e7eb",
                    paddingTop: "12px"
                  }}>
                    {asset?.asset?.description && (
                      <div style={{ 
                        marginBottom: "10px",
                        fontSize: "13px",
                        lineHeight: "1.5"
                      }}>
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#9ca3af", 
                          marginBottom: "4px",
                          fontWeight: "500"
                        }}>
                          Description
                        </div>
                        <div style={{ 
                          color: "#374151",
                          wordBreak: "break-word"
                        }}>
                          {asset?.asset?.description}
                        </div>
                      </div>
                    )}
                    
                    <div className="row g-2" style={{ marginTop: "8px" }}>
                      {asset?.asset?.serial_number && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Serial #
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151" }}>
                            {asset?.asset?.serial_number}
                          </div>
                        </div>
                      )}
                      {asset?.asset?.ext_id && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            FA No
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151" }}>
                            {asset?.asset?.ext_id}
                          </div>
                        </div>
                      )}
                      {asset?.asset?.current_value && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Value
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "600" }}>
                            {asset?.asset?.current_value}
                          </div>
                    </div>
                      )}
                      {asset?.issue_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Assigned
                    </div>
                          <div style={{ fontSize: "12px", color: "#374151" }}>
                            {formatDateHandler2(asset?.issue_date)}
                    </div>
                    </div>
                      )}
                      {asset?.return_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Return Date
                    </div>
                          <div style={{ fontSize: "12px", color: "#374151" }}>
                            {formatDateHandler2(asset?.return_date)}
                    </div>
                    </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  return (
    <>

{
  isMobile ?
  <div className="row" style={{ marginLeft: "8px", marginRight: "8px" }}>    
              {!loading && assets.length === 0 ? (
                <EmptyState />
              ) : (
                <GridView />
              )}
              {assets.length > 0 && (
                <div className="my-2 d-flex justify-content-end ">
                  <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                  </div>
                </div>
              )}
            </div>
  :
  <div className="row">
    <div className="col-12">
      {!loading && assets.length === 0 ? (
        <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
          <EmptyState />
        </div>
      ) : (
        <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
          <style>{`
            .modern-table .ant-table-tbody > tr {
              background-color: #ffffff !important;
            }
            .modern-table .ant-table-tbody > tr:hover > td {
              background-color: #f5f5f5 !important;
            }
            .modern-table .ant-table-thead > tr > th {
              background-color: #f8f9fa !important;
              font-weight: 600;
              color: #333;
              border-bottom: 2px solid #e0e0e0;
              padding: 10px 12px;
              font-size: 13px;
            }
            .modern-table .ant-table-tbody > tr > td {
              border-bottom: 1px solid #f0f0f0;
              padding: 10px 12px;
              font-size: 13px;
              vertical-align: middle !important;
            }
            .modern-table .ant-table-thead > tr > th {
              vertical-align: middle !important;
            }
            .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
              border-top: 1px solid #f0f0f0;
              background-color: #ffffff;
              border-bottom-left-radius: 12px;
              border-bottom-right-radius: 12px;
            }
          `}</style>
          <div className="table-responsive" style={{ overflowX: "auto" }}>
    <Table
              className="mb-0 modern-table"
              style={{ 
                borderRadius: "12px",
                minWidth: "100%"
              }}
              scroll={{ x: "max-content" }}
      columns={columns}
      dataSource={assets}
              rowKey={(record) => record.id}
      loading={loading}
      pagination={{
          total: pageSettings?.total,
          pageSize: pageSettings?.pageSize,
          showSizeChanger: true,
          pageSizeOptions: pageSizeOptions,
          itemRender: itemRender,
          position:"right",
          current:pageSettings?.page,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                  style: { padding: "16px" }
      }}
      onChange={handleChange}
  />
          </div>
        </div>
      )}
    </div>
  </div>

}
        
   

    </>
  );
};


export default Assets